import React from 'react';

interface TextAreaProps {
  value: string;
  rows: number;
  changeValue: (value: string) => void;
  placeholder: string;
}

const TextArea: React.FC<TextAreaProps> = props => {
  return (
    <textarea
      className="w-full p-2 rounded-lg focus:outline-none transition-all"
      rows={props.rows}
      placeholder={props.placeholder}
      value={props.value}
      onChange={e => props.changeValue(e.target.value)}
      required
      style={{
        background: 'var(--input-bg)',
        border: '1px solid var(--input-border)',
        color: 'var(--input-color)',
        resize: 'vertical'
      }}
    />
  );
};

export default TextArea;
